// D:\project_Dustre\DustreFront\src\pages\ClientPanel\Products\ProductsModal\NewProductModal.tsx

import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled, { keyframes } from 'styled-components'; // Importar 'styled' e 'keyframes'

import {
  ModalOverlay,
  ModalContent,
  CloseButton,
  Input,
  Label,
  FieldGroup,
  ButtonGroup,
  Tag,
  TagsContainer,
  SelectStyled,
  GradButton,
  GradContainer,
  ImportButton,
  CancelButton,
  SaveButton,
  SuggestionsContainer,
  SuggestionsList,
  SuggestionItem,
} from './stylemodal';

import CloseIcon from '../../../../assets/produtcss/close.svg'
import importIcon from '../../../../assets/produtcss/importtwo.svg'
import saveIcon from '../../../../assets/produtcss/saveprodut.svg'

import ImportPatternModal from '../Importmodal/ImportPatternModal'
// -----------------------------------------------------------
// NOVOS COMPONENTES E ESTILOS PARA A NOTIFICAÇÃO
// -----------------------------------------------------------

const fadeInOut = keyframes`
  0% { opacity: 0; transform: translateY(20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(20px); }
`;

const NotificationContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #4CAF50; /* Verde para sucesso */
  color: white;
  padding: 15px 25px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  animation: ${fadeInOut} 4s ease-in-out forwards; /* 4 segundos de animação */
  display: flex;
  align-items: center;
  gap: 10px;
`;

// Opcional: Adicionar um ícone de "check" ou similar, se tiver um SVG
const CheckIcon = styled.img`
  width: 20px;
  height: 20px;
`;

// -----------------------------------------------------------
// FIM DOS NOVOS COMPONENTES E ESTILOS PARA A NOTIFICAÇÃO
// -----------------------------------------------------------


// Interfaces para os dados da Família, Cores e AGORA também do Tipo (GroupBackend)
interface FamilyBackend {
  id: number;
  name: string;
}

interface TypeBackend {
  id: number;
  name: string;
}

interface ColorBackend {
  id: number;
  name: string;
  hexCode?: string;
}

interface ProductToEditType {
  id?: number;
  code?: string;
  name: string;
  family: string;
  type: string;
  colors: string[];
  gradValues: number[];
  pricing: string;
  status?: boolean;
}

interface NewProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (product: {
    id?: number;
    name: string;
    family: string;
    type: string;
    colors: string[];
    gradValues: number[];
    pricing: string;
    status?: boolean;
  }) => Promise<void>;
  productToEdit: ProductToEditType | null;
}

const NewProductModal: React.FC<NewProductModalProps> = ({
  isOpen,
  onClose,
  onSave,
  productToEdit,
}) => {
  const [name, setName] = useState('');
  const [family, setFamily] = useState('');
  const [type, setType] = useState('');
  const [colors, setColors] = useState<string[]>([]);
  const [colorInput, setColorInput] = useState('');
  const [gradValues, setGradValues] = useState<number[]>([]);
  const [pricingInput, setPricingInput] = useState('');
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const [familySuggestions, setFamilySuggestions] = useState<FamilyBackend[]>([]);
  const [showFamilySuggestions, setShowFamilySuggestions] = useState(false);
  const familyInputRef = useRef<HTMLInputElement>(null);
  const familySuggestionsContainerRef = useRef<HTMLUListElement>(null);

  const [typeSuggestions, setTypeSuggestions] = useState<TypeBackend[]>([]);
  const [showTypeSuggestions, setShowTypeSuggestions] = useState(false);
  const typeInputRef = useRef<HTMLInputElement>(null);
  const typeSuggestionsContainerRef = useRef<HTMLUListElement>(null);

  const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // NOVO ESTADO para a notificação
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  // Efeito para gerenciar o tempo de exibição da notificação
  useEffect(() => {
    if (showNotification) {
      const timer = setTimeout(() => {
        setShowNotification(false);
        setNotificationMessage('');
      }, 3000); // Notificação visível por 3 segundos

      return () => clearTimeout(timer);
    }
  }, [showNotification]);

  const fetchColorsForFamily = useCallback(async (familyId: number) => {
    console.log(
      `[DEBUG - Cores] Iniciando busca de cores para família ID: ${familyId}`,
    );
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FASHION_ORDERS_BASE_URL}/fashion-product/families/${familyId}/colors`,
      );
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Erro ao buscar cores da família: ${response.status} ${response.statusText} - ${errorText}`,
        );
      }
      const data: { colors: ColorBackend[] } = await response.json();
      console.log(
        `[DEBUG - Cores] Cores recebidas do backend para ID ${familyId}:`,
        data,
      );
      const newColors = (data.colors || []).map((color) => color.name);
      setColors((prevColors) => {
        const uniqueNewColors = newColors.filter((c) => !prevColors.includes(c));
        return [...prevColors, ...uniqueNewColors];
      });
    } catch (error) {
      console.error('Erro ao buscar cores da família:', error);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      if (productToEdit) {
        setName(productToEdit.name || '');
        setFamily(productToEdit.family || '');
        setType(productToEdit.type || '');
        setGradValues(productToEdit.gradValues || []);
        setPricingInput(productToEdit.pricing || '');

        if (productToEdit.family) {
          console.log(
            `[DEBUG - Edição] Buscando ID para a família: ${productToEdit.family}`,
          );
          fetch(
            `${process.env.REACT_APP_FASHION_ORDERS_BASE_URL}/fashion-product/families?name=${encodeURIComponent(
              productToEdit.family,
            )}`,
          )
            .then((res) => {
              if (!res.ok) {
                console.warn(
                  `Erro ao buscar ID da família "${productToEdit.family}" para edição: ${res.status}`,
                );
                throw new Error(`Erro ao buscar ID da família: ${res.status}`);
              }
              return res.json();
            })
            .then((data: FamilyBackend[]) => {
              const matchedFamily = data.find(
                (f) => f.name === productToEdit.family,
              );
              if (matchedFamily) {
                setColors([]);
                fetchColorsForFamily(matchedFamily.id);
              } else {
                console.warn(
                  `Família "${productToEdit.family}" não encontrada no backend durante edição. Carregando cores existentes do produto.`,
                );
                setColors(productToEdit.colors || []);
              }
            })
            .catch((error) => {
              console.error(
                'Erro ao buscar família para edição, carregando cores existentes do produto:',
                error,
              );
              setColors(productToEdit.colors || []);
            });
        } else {
          setColors(productToEdit.colors || []);
        }
      } else {
        setName('');
        setFamily('');
        setType('');
        setColors([]);
        setColorInput('');
        setGradValues([]);
        setPricingInput('');
      }
      setFamilySuggestions([]);
      setShowFamilySuggestions(false);
      setTypeSuggestions([]);
      setShowTypeSuggestions(false);
    }
  }, [productToEdit, isOpen, fetchColorsForFamily]);

  const debouncedFetchFamilySuggestions = useCallback((query: string) => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    debounceTimeoutRef.current = setTimeout(async () => {
      try {
        const url = `${process.env.REACT_APP_FASHION_ORDERS_BASE_URL}/fashion-product/families?name=${encodeURIComponent(
          query,
        )}`;
        console.log(`[DEBUG - Família] Requisição para: ${url}`);
        const response = await fetch(url);
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(
            `Erro ao buscar sugestões de família: ${response.status} ${response.statusText} - ${errorText}`,
          );
        }
        const data: FamilyBackend[] = await response.json();
        console.log('[DEBUG - Família] Sugestões recebidas:', data);
        setFamilySuggestions(data);
        setShowFamilySuggestions(data.length > 0);
      } catch (error) {
        console.error('Erro ao buscar sugestões de família:', error);
        setFamilySuggestions([]);
        setShowFamilySuggestions(false);
      }
    }, 300);
  }, []);

  const debouncedFetchTypeSuggestions = useCallback((query: string) => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    debounceTimeoutRef.current = setTimeout(async () => {
      try {
        const url = `${process.env.REACT_APP_FASHION_ORDERS_BASE_URL}/fashion-product/groups?name=${encodeURIComponent(
          query,
        )}`;
        console.log(`[DEBUG - Tipo] Requisição para: ${url}`);
        const response = await fetch(url);
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(
            `Erro ao buscar sugestões de tipo: ${response.status} ${response.statusText} - ${errorText}`,
          );
        }
        const data: TypeBackend[] = await response.json();
        console.log('[DEBUG - Tipo] Sugestões recebidas:', data);
        setTypeSuggestions(data);
        setShowTypeSuggestions(data.length > 0);
      } catch (error) {
        console.error('Erro ao buscar sugestões de tipo:', error);
        setTypeSuggestions([]);
        setShowTypeSuggestions(false);
      }
    }, 300);
  }, []);

  useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  const handleAddColor = () => {
    const trimmed = colorInput.trim();
    if (trimmed && !colors.includes(trimmed)) {
      setColors([...colors, trimmed]);
    }
    setColorInput('');
  };

  const handleRemoveColor = (colorToRemove: string) => {
    setColors(colors.filter((color) => color !== colorToRemove));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      handleAddColor();
    }
  };

  const toggleGrad = (val: number) => {
    if (gradValues.includes(val)) {
      setGradValues(gradValues.filter((v) => v !== val));
    } else {
      setGradValues([...gradValues, val].sort((a, b) => a - b));
    }
  };

  const handleSave = async () => {
    if (
      !name.trim() ||
      !family.trim() ||
      !type.trim() ||
      !pricingInput.trim()
    ) {
      alert(
        'Por favor, preencha todos os campos obrigatórios (Nome, Família, Tipo, Precificação).',
      );
      return;
    }

    const cleanPricing = pricingInput
      .replace('R$', '')
      .replace(/\./g, '')
      .replace(',', '.')
      .trim();
    const parsedPricing = parseFloat(cleanPricing);

    if (isNaN(parsedPricing)) {
      alert(
        'Precificação inválida. Por favor, insira um valor numérico válido.',
      );
      return;
    }

    const productData = {
      id: productToEdit?.id,
      name,
      family,
      type,
      colors,
      gradValues,
      pricing: parsedPricing.toString(),
      status:
        productToEdit?.id !== undefined
          ? productToEdit.status !== undefined
            ? productToEdit.status
            : true
          : true,
    };

    try {
      await onSave(productData);
      setNotificationMessage('Produto salvo com sucesso!'); // Define a mensagem
      setShowNotification(true); // Exibe a notificação
      onClose(); // Fecha o modal após salvar (se essa for a intenção)
    } catch (error) {
      console.error('Erro ao tentar salvar produto no modal:', error);
      alert('Erro ao salvar produto. Verifique o console para mais detalhes.');
      setNotificationMessage('Erro ao salvar produto!'); // Mensagem de erro
      setShowNotification(true); // Exibe a notificação de erro também
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        familyInputRef.current &&
        !familyInputRef.current.contains(event.target as Node) &&
        familySuggestionsContainerRef.current &&
        !familySuggestionsContainerRef.current.contains(event.target as Node)
      ) {
        setShowFamilySuggestions(false);
      }
      if (
        typeInputRef.current &&
        !typeInputRef.current.contains(event.target as Node) &&
        typeSuggestionsContainerRef.current &&
        !typeSuggestionsContainerRef.current.contains(event.target as Node)
      ) {
        setShowTypeSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelectFamilySuggestion = (selectedFamily: FamilyBackend) => {
    setFamily(selectedFamily.name);
    setShowFamilySuggestions(false);
    setFamilySuggestions([]);
    setColors([]);
    fetchColorsForFamily(selectedFamily.id);
  };

  const handleFamilyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFamilyValue = e.target.value;
    setFamily(newFamilyValue);
    if (newFamilyValue === '') {
      console.log('[DEBUG - Cores] Campo Família limpo. Limpando cores.');
      setColors([]);
    }
    debouncedFetchFamilySuggestions(newFamilyValue);
  };

  const handleFamilyFocus = () => {
    debouncedFetchFamilySuggestions(family);
    setShowFamilySuggestions(true);
  };

  const handleSelectTypeSuggestion = (selectedType: TypeBackend) => {
    setType(selectedType.name);
    setShowTypeSuggestions(false);
    setTypeSuggestions([]);
  };

  const handleTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTypeValue = e.target.value;
    setType(newTypeValue);
    debouncedFetchTypeSuggestions(newTypeValue);
  };

  const handleTypeFocus = () => {
    debouncedFetchTypeSuggestions(type);
    setShowTypeSuggestions(true);
  };

  const formatPricingInput = (value: string) => {
    let val = value.replace(/[^0-9,.]/g, '');
    val = val.replace(/,/g, '.');

    const parts = val.split('.');
    if (parts.length > 2) {
      val = parts[0] + '.' + parts.slice(1).join('');
    }

    if (val.startsWith('0') && val.length > 1 && !val.includes('.')) {
      val = val.substring(1);
    } else if (
      val.length > 1 &&
      val.includes('.') &&
      val.indexOf('.') === 1 &&
      val.startsWith('0')
    ) {
      // Keeps '0.X'
    } else if (val.startsWith('0') && val.length > 1 && val.charAt(1) !== '.') {
      val = parseFloat(val).toString();
    }

    if (val.includes('.')) {
      const [integer, decimal] = val.split('.');
      return `R$ ${integer.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        '.',
      )},${decimal.substring(0, 2)}`;
    } else if (val) {
      return `R$ ${val.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
    } else {
      return '';
    }
  };

  const handlePricingInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace('R$', '').replace(/\./g, '').trim();
    setPricingInput(formatPricingInput(rawValue));
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h2>
            {productToEdit
              ? `Editar produto: ${productToEdit.code || ''}`
              : 'Novo produto'}
          </h2>
          <CloseButton onClick={onClose}>
            <img src={CloseIcon} alt='Fechar' />
          </CloseButton>
        </div>

        <Label>Nome do produto</Label>
        <Input
          placeholder='Digite aqui'
          value={name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setName(e.target.value)
          }
          required
        />

        <FieldGroup>
          <SuggestionsContainer>
            <Label>Episódio</Label>
            <Input
              ref={familyInputRef}
              placeholder='Digite aqui'
              value={family}
              onChange={handleFamilyChange}
              onFocus={handleFamilyFocus}
              autoComplete='off'
              required
            />
            {showFamilySuggestions && familySuggestions.length > 0 && (
              <SuggestionsList ref={familySuggestionsContainerRef}>
                {familySuggestions.map((sug) => (
                  <SuggestionItem
                    key={sug.id}
                    onClick={() => handleSelectFamilySuggestion(sug)}
                  >
                    {sug.name}
                  </SuggestionItem>
                ))}
              </SuggestionsList>
            )}
          </SuggestionsContainer>

          <SuggestionsContainer>
            <Label>Grupo</Label>
            <Input
              ref={typeInputRef}
              placeholder='Digite aqui'
              value={type}
              onChange={handleTypeChange}
              onFocus={handleTypeFocus}
              autoComplete='off'
              required
            />
            {showTypeSuggestions && typeSuggestions.length > 0 && (
              <SuggestionsList ref={typeSuggestionsContainerRef}>
                {typeSuggestions.map((sug) => (
                  <SuggestionItem
                    key={sug.id}
                    onClick={() => handleSelectTypeSuggestion(sug)}
                  >
                    {sug.name}
                  </SuggestionItem>
                ))}
              </SuggestionsList>
            )}
          </SuggestionsContainer>
        </FieldGroup>

        <Label>Cores</Label>
        <Input
          placeholder='Digite uma cor e pressione Enter ou vírgula'
          value={colorInput}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setColorInput(e.target.value)
          }
          onKeyDown={handleKeyDown}
        />
        <TagsContainer>
          {colors.map((color, index) => (
            <Tag key={index} onClick={() => handleRemoveColor(color)}>
              {color}{' '}
              <span style={{ marginLeft: '5px', cursor: 'pointer' }}>x</span>
            </Tag>
          ))}
        </TagsContainer>

        <Label>Graduação</Label>
        <GradContainer>
          {[24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48].map((value) => (
            <GradButton
              key={value}
              selected={gradValues.includes(value)}
              onClick={() => toggleGrad(value)}
            >
              {value}
            </GradButton>
          ))}
        </GradContainer>

        <Label>Precificação</Label>
        <Input
          placeholder='Digite aqui (ex: 120,00)'
          value={pricingInput}
          onChange={handlePricingInputChange}
          required
        />

        <ButtonGroup>
          <ImportButton onClick={() => setIsImportModalOpen(true)}>
            <img src={importIcon} alt='Importar' />
            Importar padrão
          </ImportButton>
          <CancelButton onClick={onClose}>Cancelar</CancelButton>
          <SaveButton onClick={handleSave}>
            <img src={saveIcon} alt='Salvar' />
            Salvar produto
          </SaveButton>
        </ButtonGroup>
      </ModalContent>

      <ImportPatternModal
        isOpen={isImportModalOpen}
        onClose={() => setIsImportModalOpen(false)}
      />

      {/* ----------------------------------------------------------- */}
      {/* NOVO COMPONENTE DE NOTIFICAÇÃO - Exibido no canto inferior direito */}
      {/* ----------------------------------------------------------- */}
      {showNotification && (
        <NotificationContainer>
          {/* Você pode adicionar um ícone de "check" aqui se tiver um SVG para isso */}
          {/* <CheckIcon src={checkSvgIcon} alt="Sucesso" /> */}
          <span>{notificationMessage}</span>
        </NotificationContainer>
      )}
    </ModalOverlay>
  );
};

export default NewProductModal;